import { useEffect } from 'react';

/**
 * Reserves room at the bottom of the viewport for the fixed pit lane panel.
 *
 * The heights themselves stay in theme.css rather than here, because they vary
 * by tier — a touch bar is taller than a mouse one — and TypeScript cannot see
 * media queries or the `touch-ui` class. So this only picks *which* token
 * applies; substitution happens where the property is read (App.css,
 * TeamStintsModal.css), which means it resolves per-tier for free.
 */
export function usePitReservedBottom(isPitPanelOpen: boolean): void {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--pit-reserved-bottom',
      isPitPanelOpen ? 'var(--pit-bar-open-h)' : 'var(--pit-bar-h)',
    );
    return () => {
      document.documentElement.style.removeProperty('--pit-reserved-bottom');
    };
  }, [isPitPanelOpen]);
}
